export const isGnosisSafe = async () => {
  // Not running in an IFrame --> Not in a GnosisSafe App
  if (window?.parent === window) {
    return false;
  }

  const { default: SdkInstance } = await import('@gnosis.pm/safe-apps-sdk');
  const sdk = new SdkInstance();
  const safe = await sdk.safe.getInfo();

  return !!safe;
};
